import script from "./UpConfirma.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpConfirma.vue?vue&type=script&lang=ts&setup=true"

import "./UpConfirma.vue?vue&type=style&index=0&id=6c9e1cfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9e1cfa"]])

export default __exports__